<template>
  <div class="index-container">
    <orderFilter ref="orderFilter" :status="status">
      <el-button type="primary" size="small" @click="handleQuery()"
        >查询</el-button
      >
      <el-button type="warning" size="small" @click="handleExport()"
        >导出</el-button
      >
      <el-button type="success" size="small" @click="handleSummary()"
        >汇总</el-button
      >
    </orderFilter>
    <div class="tabs-container">
      <el-tabs v-model="status" type="border-card" @tab-click="activeChange">
        <el-tab-pane name="All">
          <span slot="label"
            ><i class="el-icon-s-grid"></i> 全部<span style="color: red"
              >({{ all }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Booking">
          <span slot="label"
            ><i class="el-icon-date"></i> 待接单<span style="color: red"
              >({{ booking }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Changing">
          <span slot="label"
            ><i class="el-icon-message-solid"></i>*改约中<span
              style="color: red"
              >({{ changing }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Appointed">
          <span slot="label"
            ><i class="el-icon-s-promotion"></i>待派单
            <span style="color: red">({{ appointed }})</span></span
          >
        </el-tab-pane>
        <el-tab-pane name="Dispatched">
          <span slot="label"
            ><i class="el-icon-user-solid"></i>已派单<span style="color: red"
              >({{ dispatched }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Serviced">
          <span slot="label"
            ><i class="el-icon-success"></i>已完成<span style="color: red"
              >({{ completed }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Balanced">
          <span slot="label"
            ><i class="el-icon-money"></i>已结算<span style="color: red"
              >({{ balanced }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Rejected">
          <span slot="label"
            ><i class="el-icon-remove"></i>已拒绝<span
              >({{ rejected }})</span
            ></span
          >
        </el-tab-pane>
        <el-tab-pane name="Canceled">
          <span slot="label"
            ><i class="el-icon-error"></i>已取消<span
              >({{ canceled }})</span
            ></span
          >
        </el-tab-pane>
      </el-tabs>
      <div class="tab-content">
        <orderList ref="orderList" :filter="filter" @update="handleQuery" />
      </div>
    </div>
    <orderSummary ref="orderSummary" />
  </div>
</template>
<script>
import orderList from "./components/orderList.vue";
import orderFilter from "./components/orderFilter.vue";
import orderSummary from "./components/orderSummary.vue";
import {
  getQueryCount,
  exportOrder,
} from "@/api/bussiness/order";
export default {
  components: { orderFilter, orderList, orderSummary },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      filter: {
        status: "Booking",
      },
      loadInstance: "",
      status: "Booking",
      all: 0,
      booking: 0,
      changing: 0,
      appointed: 0,
      dispatched: 0,
      completed: 0,
      rejected: 0,
      balanced: 0,
      canceled: 0,
      intervalId: "",
    };
  },
  methods: {
    handleSummary() {
      this.$refs.orderSummary.show();
    },
    activeChange() {
      this.handleQuery();
    },
    handleQuery() {
      let tempfilter = this.$refs.orderFilter.getfilter();
      tempfilter.status = this.status;
      this.filter = tempfilter;
      getQueryCount(this.filter).then((response) => {
        if (response) {
          this.all = response.all;
          this.booking = response.booking;
          this.changing = response.changing;
          this.appointed = response.appointed;
          this.dispatched = response.dispatched;
          this.completed = response.completed;
          this.balanced = response.balanced;
          this.rejected = response.rejected;
          this.canceled = response.canceled;
        }
      });
    },
    handleExport() {
      let tempfilter = this.$refs.orderFilter.getfilter();
      tempfilter.status = this.status;
      let param = {
        tenant: tempfilter.tenant ? tempfilter.tenant.Key : "",
        search: tempfilter.search,
        status: tempfilter.status,
        source: tempfilter.source,
        dateType: tempfilter.dateType,
        beginDate: tempfilter.beginDate,
        endDate: tempfilter.endDate,
      };
      this.loadInstance = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      exportOrder(param)
        .then((res) => {
          this.loadInstance.close();
          if (res) {
            window.open(this.baseUrl + res);
          }
        })
        .catch((ex) => {
          this.errorMsg("导出出错：" + ex);
          this.loadInstance.close();
        });
    },
  },
  mounted() {
    this.handleQuery();
  },
};
</script>
<style lang="scss" scoped>
.index-container {
  .pagination {
    margin-top: 10px;
    text-align: right;
  }
  padding: 10px;
  .input {
    width: 150px;
  }
  .tabs-container {
    /deep/.el-tabs--border-card > .el-tabs__content {
      padding: 0;
      height: 1px;
    }
    .tab-content {
      margin-top: -2px;
      border: 1px solid #dcdfe6;
      border-top: 0;
      padding: 15px;
      background: #fff;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
    }
  }
}
</style>